import { WorkStarterPrompts } from '../work/WorkStarterPrompts';

/**
 * What an empty org chart offers instead of a create button
 * (app-shell ADR-013): an explanation of what this view is for, and
 * clickable first moves that fill the docked agent's composer.
 */
export const EMPTY_ORG_CHART_PROMPTS = [
  'Create our first team on the org chart.',
  'Set the first goal for that team.',
  'Watch the team work until they achieve that goal.',
];

export function OrgChartEmptyState() {
  return (
    <div className="max-w-md space-y-4 text-center" data-testid="orgchart-empty-state">
      <p className="text-muted-foreground">
        No org chart yet. This view shows the structure; the agent docked below builds it. Ask it
        to create your first team, set their first goal, then watch them achieve it.
      </p>
      <WorkStarterPrompts prompts={EMPTY_ORG_CHART_PROMPTS} />
    </div>
  );
}
